import React, { useEffect, useMemo } from "react";
import { useLocation } from "react-router";
import { Invitation } from "../components/Invitation";
import { InvitationCampaign } from "../components/Invitation/types/campaign";
import { useDispatch, useSelector } from "react-redux";
import { httpCreators } from "@ppvrbh/merchant-frontend-core";
import { INVITATION_REQUEST_ID_LIST } from "../components/Invitation/redux/invitation-constant";
import { InvitationService } from "../components/Invitation/redux/invitation-service";
import { invitationSagas } from "../components/Invitation/redux/invitation-saga";
import { generalStateSelector, GENERAL_STATE_KEY } from "../../../redux/general/general-reducer";
import { InvitationChannel } from "../components/Invitation/types/channel";
import { AppConfigKey } from "../../../shared/models/app-config";



export const InvitationScreen: React.FC = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();
  const remoteConfig = useSelector(generalStateSelector(GENERAL_STATE_KEY.REMOTE_CONFIG));
  const isGrayScreenFilter = remoteConfig?.find(({ key }) => key === AppConfigKey.GrayScreenFilter)?.value === 'true';
  const { channel, token } = useMemo(() => {
  const queryParams = new URLSearchParams(search);
    return {
      channel: queryParams.get('channel'),
      token: queryParams.get('token')
    }
  }, [search]);

  useEffect(() => {
    dispatch(httpCreators.request({
      id: INVITATION_REQUEST_ID_LIST.GET_GENERAL_CONFIG,
      sagaHandler: invitationSagas.callGeneralConfigHandler,
      service: InvitationService.getGeneralConfigs
    }));
  }, [])

  const grayScreenFilterFlag = isGrayScreenFilter && channel === InvitationChannel.ScbConnect;


  return (
    <div style={{ filter: grayScreenFilterFlag ? 'grayscale(0.5)' : 'none' }}>
      <Invitation channel={channel} token={token} campaign={InvitationCampaign.Special_GP}>
        <Invitation.Banner />
        <Invitation.FormSection />
        <Invitation.TermsSection  />
        <Invitation.SuccessSection />
      </Invitation>

    </div>
  );
};